// import React from 'react'
// import { Button, FormControl, Grid, InputBase, InputLabel, Step, StepButton, Stepper, styled, Typography } from '@mui/material';
// import { alpha } from '@mui/material/styles';

// const StyledBtn1 = styled(Button)(({ theme, isButtonDisabled }) => ({
//     width: '35%',
//     color: '#005624',
//     backgroundColor: isButtonDisabled ? '#d7d7d7' : '#99cc33',
//     borderRadius: '5px',
//     fontSize: '14.5px',
//     padding: '7px 8px',
//     fontWeight: 700,
//     transition: '0.15s',
//     textTransform: "none",
//     marginTop: '1em',
//     '&:hover': {
//         backgroundColor: isButtonDisabled ? '#d7d7d7' : '#99cc33',
//         color: isButtonDisabled ? '#000' : '#fff',
//         borderColor: isButtonDisabled ? '#d7d7d7' : '#99cc33'
//     }
// }))

// const BootstrapInput = styled(InputBase)(({ theme }) => ({
//     'label + &': {
//         marginTop: theme.spacing(3),
//     },
//     '& .MuiInputBase-input': {
//         borderRadius: 4,
//         position: 'relative',
//         backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
//         border: '1px solid',
//         borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
//         fontSize: 16,
//         width: '100%^',
//         padding: '10px 12px',
//         transition: theme.transitions.create([
//             'border-color',
//             'background-color',
//             'box-shadow',
//         ]),
//         // Use the system font instead of the default Roboto font.
//         fontFamily: [
//             '-apple-system',
//             'BlinkMacSystemFont',
//             '"Segoe UI"',
//             'Roboto',
//             '"Helvetica Neue"',
//             'Arial',
//             'sans-serif',
//             '"Apple Color Emoji"',
//             '"Segoe UI Emoji"',
//             '"Segoe UI Symbol"',
//         ].join(','),
//         '&:focus': {
//             boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//             borderColor: theme.palette.primary.main,
//         },
//     },
// }));

// const SellingQuest = () => {
//     const [activeStep, setActiveStep] = React.useState(0);
//     const [formData, setFormData] = React.useState({
//         address: '',
//         unit: '',
//         options: [],
//         firstName: '',
//         lastName: '',
//         email: '',
//         mobile: '',
//     });
//     const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad', 'Create an ad group', 'Create an ad',];


//     const allPhases = [
//         { name: 'address', label: 'Address', type: 'text', questions: 'Enter the Address' },
//         { name: 'unit', label: 'Unit', type: 'text', questions: 'Enter the Unit' },
//         { name: 'option', label: 'Select an Option', type: 'button', options: ['Option 1', 'Option 2', 'Option 3'], questions: 'Enter a Option' },
//         { name: 'option1', label: 'Select an Option1', type: 'button', options: ['Option 1', 'Option 2', 'Option 3'], questions: 'Enter a Option1' },
//         { name: 'description', label: 'Description', type: 'text', questions: 'Enter the Des' },
//         { name: 'comment', label: 'Comment', type: 'text', questions: 'Enter the Comment' },
//     ];

//     const handleNext = () => {
//         setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     };

//     const handleBack = () => {
//         setActiveStep((prevActiveStep) => prevActiveStep - 1);
//     };

//     const handleChange = (field, value) => {
//         setFormData((prevData) => ({ ...prevData, [field]: value }));
//     };

//     const getStepContent = (step) => {
//         switch (step) {
//             case 0:
//                 return (
//                     <Grid container spacing={2}>
//                         <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={index}>
//                             <FormControl variant="standard" sx={{ width: '450px' }}>
//                                 <Typography variant="h4">
//                                     Enter the Address
//                                 </Typography>
//                                 <BootstrapInput
//                                     id="bootstrap-input"
//                                     label="Address"
//                                     variant="outlined"
//                                     value={formData.address}
//                                     onChange={(e) => handleChange('address', e.target.value)}
//                                 // error={!!errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                 // helperText={errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                 />
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={index}>
//                             <FormControl variant="standard" sx={{ width: '450px' }}>
//                                 <Typography variant="h4">
//                                     Enter the Unit
//                                 </Typography>
//                                 <BootstrapInput
//                                     id="bootstrap-input"
//                                     variant="outlined"
//                                     label="Unit"
//                                     value={formData.unit}
//                                     onChange={(e) => handleChange('unit', e.target.value)}
//                                 // error={!!errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                 // helperText={errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                 />
//                             </FormControl>
//                         </Grid>
//                     </Grid>
//                 );
//             case 1:
//                 return (
//                     <Grid container spacing={2}>
//                         <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={item.name}>
//                             <Typography variant="h4">
//                                 When are you thinking about listing your home?
//                             </Typography>
//                             {item.options.map((option, optionIndex) => (
//                                 <StyledBtn1 onClick={() => handleOptionSelection(optionIndex)} key={optionIndex}>
//                                     {option}
//                                 </StyledBtn1>
//                             ))}
//                         </Grid>
//                     </Grid>
//                 );
//             case 2:
//                 return (
//                     <Grid container spacing={2}>
//                         {allPhases.slice(3, 4).map((item, index) => {
//                             return (
//                                 <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={item.name}>
//                                     <Typography variant="h4">
//                                         {item.questions}
//                                     </Typography>
//                                     {item.options.map((option, optionIndex) => (
//                                         <StyledBtn1 onClick={() => handleOptionSelection(optionIndex)} key={optionIndex}>
//                                             {option}
//                                         </StyledBtn1>
//                                     ))}
//                                 </Grid>
//                             )
//                         })
//                         }
//                         <Button variant="contained" color="primary" onClick={handleNext}>
//                             Next
//                         </Button>
//                     </Grid>
//                 );
//             case 3:
//                 return (
//                     <Grid container spacing={2}>
//                         {allPhases.slice(4, 5).map((item, index) => {
//                             return (
//                                 <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={index}>
//                                     <FormControl variant="standard" sx={{ width: '450px' }}>
//                                         <Typography variant="h4">
//                                             {item.questions}
//                                         </Typography>
//                                         <InputLabel shrink htmlFor="bootstrap-input">

//                                         </InputLabel>
//                                         <BootstrapInput
//                                             id="bootstrap-input"
//                                             label={item.label}
//                                             variant="outlined"
//                                             name={item.name}
//                                         // error={!!errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                         // helperText={errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                         />
//                                     </FormControl>
//                                 </Grid>
//                             )
//                         })
//                         }
//                         <Button variant="contained" color="primary" onClick={handleNext}>
//                             Next
//                         </Button>
//                     </Grid>
//                 );
//             case 4:
//                 return (
//                     <Grid container spacing={2}>
//                         {allPhases.slice(5, 6).map((item, index) => {
//                             return (
//                                 <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }} key={index}>
//                                     <FormControl variant="standard" sx={{ width: '450px' }}>
//                                         <Typography variant="h4">
//                                             {item.questions}
//                                         </Typography>
//                                         <InputLabel shrink htmlFor="bootstrap-input">

//                                         </InputLabel>
//                                         <BootstrapInput
//                                             id="bootstrap-input"
//                                             label={item.label}
//                                             variant="outlined"
//                                             name={item.name}
//                                         // error={!!errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                         // helperText={errors[currentPhaseQuestions[currentQuestionIndex].name]}
//                                         />
//                                     </FormControl>
//                                 </Grid>
//                             )
//                         })
//                         }
//                         <Button variant="contained" color="primary" onClick={handleNext}>
//                             Next
//                         </Button>
//                     </Grid>
//                 );


//             default:
//                 return 'Unknown step';
//         }
//     };


//     return (
//         <Grid>
//             <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }}>
//                 <Stepper nonLinear activeStep={activeStep}>
//                     {steps.map((label, index) => (
//                         <Step key={label} >
//                             <StepButton color="inherit" >
//                                 {label}
//                             </StepButton>
//                         </Step>
//                     ))}
//                 </Stepper>
//             </Grid>
//             <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }}>
//                 {getStepContent(activeStep)}
//             </Grid>
//             <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '1em' }}>
//                 <Button disabled={activeStep === 0} onClick={handleBack}>
//                     Back
//                 </Button>
//                 <Button variant="contained" color="primary" onClick={handleNext} disabled={!formData[steps[activeStep].fields[0]]}>
//                     {isLastStep ? 'Finish' : 'Next'}
//                 </Button>
//             </Grid>
//         </Grid>
//     )
// }

// export default SellingQuest

import React, { useState } from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Typography,
    TextField,
    InputBase,
    ButtonGroup,
    styled,
    Grid,
    MobileStepper,
    FormControl,
    InputLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Box,
    Stack,
    Snackbar,
    Alert,
    useMediaQuery
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PropTypes from 'prop-types';
import { Check } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const StyledInput = styled(InputLabel)({
    fontSize: '20px',
    color: '#fff',
    fontWeight: 500
});

const StyledBtn1 = styled(Button)(({ theme, isSelected, Matches }) => ({
    width: Matches ? '300px' : '480px',
    color: '#fff',
    backgroundColor: isSelected ? '#978A7D' : '#978A7D',
    borderRadius: '5px',
    fontSize: '15px',
    padding: '7px 8px',
    transition: '0.15s',
    textTransform: "none",
    marginTop: '1em',
    border: 'none',
    '&:hover': {
        backgroundColor: '#444444',
        color: '#fff',
        borderColor: '#fff'
    }
}));

const StyledBtn = styled(Button)(({ theme, isSelected, Matches }) => ({
    width: Matches ? '300px' : '480px',
    color: '#fff',
    backgroundColor: isSelected ? '#978A7D' : '#978A7D',
    borderRadius: '5px',
    fontSize: '15px',
    padding: '7px 8px',
    transition: '0.15s',
    textTransform: "none",
    marginTop: '1em',
    border: 'none',
    '&:hover': {
        backgroundColor: '#444444',
        color: '#fff',
        borderColor: '#fff'
    }
}));

const BootstrapInput = styled(InputBase)(({ theme, Matches }) => ({
    width: Matches ? '300px' : '540px',
    'label + &': {
        marginTop: theme.spacing(3),
        color: '#000'
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        textAlign: 'start',
        backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
        fontSize: 16,
        width: '100%',
        padding: '5px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
        theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background:
            theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});


function BpCheckbox(props) {
    return (
        <Checkbox
            sx={{
                color: '#fff',
                '&:hover': { bgcolor: 'transparent' },
            }}
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            inputProps={{ 'aria-label': 'Checkbox demo' }}
            {...props}
        />
    );
}

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
};





const SellingQuest = (props) => {
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [showEmailMobile, setShowEmailMobile] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isSuccess, setIsSuccess] = React.useState(true);
    const history = useNavigate();
    const matches = useMediaQuery('(max-width:600px)');
    const [state, setState] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical, horizontal, open, } = state;

    const { steps, optionsSets } = props

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleOptionClick = (option, field) => {
        setFormData((prevData) => ({ ...prevData, [field]: option }));
        setSelectedOption(option);
        handleNext();
    };

    const handleChange = (field, value) => {
        setFormData((prevData) => ({ ...prevData, [field]: value }));
    };

    const handleSnackbarClose = () => {
        setState({ open: false });
    };

    const handleSubmit = () => {
        setActiveStep(0);
        setFormData('');
        setShowEmailMobile(false);
        setIsSuccess(true);
        setState({ open: true, vertical: 'bottom', horizontal: 'right' });
        console.log("formData", formData)
        setTimeout(() => {
            window.location.reload();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 4000);


    };

    const handleShowFields = () => {
        setShowEmailMobile(true);
    };

    const isLastStep = activeStep === steps.length - 1;
    const isOptionsStep = steps[activeStep]?.fields?.[0]?.startsWith('options');

    return (
        <div>
            {/* <Stepper activeStep={activeStep} connector={<QontoConnector />} sx={{width: '620px'}}>
                {steps.map((step) => (
                    <Step key={step.label}>
                       <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
                    </Step>
                ))}
            </Stepper> */}
            <div>
                <>
                    {steps[activeStep]?.fields?.map((field, index) => (
                        <div key={field}>
                            <Grid container spacing={2}>
                                {optionsSets[field] ? (
                                    <>
                                        {
                                            (field === 'typeofhome') ?
                                                <Grid item xs display='flex' flexDirection="column" justifyContent="center" alignItems="center">
                                                    <Typography variant="h4" color="#fff" sx={{
                                                        mt: '1em', fontSize: matches ? '22px' : null,
                                                        fontWeight: matches ? 600 : null,
                                                        letterSpacing: '-0.03em',
                                                    }}>{steps[activeStep].fieldName[index]}</Typography>
                                                    <Typography sx={{ borderBottom: '2px solid #444444', borderBottomWidth: '50%', width: '140px', mt: '10px' }}></Typography>
                                                    <Grid item xs={matches ? 12 : 8} sx={{ mt: '1em' }}>
                                                        {optionsSets[field].map((option) => (
                                                            <StyledBtn1
                                                                key={option.value}
                                                                variant={formData[field] === option.component ? 'contained' : 'outlined'}
                                                                isSelected={selectedOption === option.value}
                                                                onClick={() => handleOptionClick(option.value, field)}
                                                                sx={{ width: matches ? '140px' : '180px', height: matches ? '120px' : '150px', ml: '1em', fontWeight: 400 }}
                                                                Matches={matches}
                                                            >
                                                                {option.component}
                                                            </StyledBtn1>
                                                        ))}

                                                    </Grid>
                                                </Grid>
                                                :
                                                <Grid item xs={12} sx={{ mt: '1em', }} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                                    {
                                                        (field === 'optionswithmultiline') ?
                                                            <Typography variant="h4" sx={{
                                                                maxWidth: matches ? null : '70%', color: '#fff', fontSize: matches ? '22px' : null,
                                                                fontWeight: matches ? 600 : null,
                                                                letterSpacing: '-0.03em',
                                                            }}>{steps[activeStep].fieldName[index]}</Typography>
                                                            :
                                                            <Typography variant="h4" color='#fff' sx={{
                                                                mb: '1em',
                                                                fontSize: matches ? '22px' : null,
                                                                fontWeight: matches ? 600 : null,
                                                                letterSpacing: '-0.03em',
                                                            }}>{steps[activeStep].fieldName[index]}</Typography>
                                                    }
                                                    {
                                                        (field === 'optionswithinfo') ?
                                                            <>
                                                                {optionsSets[field].map((option) => (
                                                                    <StyledBtn1
                                                                        key={option}
                                                                        variant={formData[field] === option ? 'contained' : 'outlined'}
                                                                        isSelected={selectedOption === option}
                                                                        onClick={() => handleOptionClick(option, field)}
                                                                        Matches={matches}
                                                                    >
                                                                        {option}
                                                                    </StyledBtn1>
                                                                ))}
                                                                <Typography variant="h5" color='#fff' sx={{ mt: '1em', }}>If so, we can save you an extra $2,500!</Typography>
                                                            </>
                                                            :
                                                            <>
                                                                {optionsSets[field].map((option) => (
                                                                    <StyledBtn1
                                                                        key={option}
                                                                        variant={formData[field] === option ? 'contained' : 'outlined'}
                                                                        isSelected={selectedOption === option}
                                                                        onClick={() => handleOptionClick(option, field)}
                                                                        Matches={matches}
                                                                    >
                                                                        {option}
                                                                    </StyledBtn1>
                                                                ))}
                                                            </>
                                                    }

                                                </Grid>
                                        }
                                    </>

                                ) : (
                                    <>
                                        {
                                            (field === "firstName") ? (
                                                <Grid item xs display='flex' flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '10px' }}>
                                                    <Typography
                                                        variant="h4"
                                                        color='#fff'
                                                        sx={{
                                                            fontSize: matches ? '22px' : null,
                                                            fontWeight: matches ? 600 : null,
                                                            letterSpacing: '-0.03em',
                                                        }}
                                                    >
                                                        What is your name?
                                                    </Typography>
                                                    <Typography variant="h5" sx={{ borderBottom: '2px solid #444444', borderBottomWidth: '50%', width: '140px', mt: '10px', mb: '10px' }}></Typography>
                                                    <Grid item xs={12}>
                                                        <FormControl variant="standard">
                                                            <StyledInput shrink htmlFor="bootstrap-input" >First Name</StyledInput>
                                                            <BootstrapInput
                                                                required
                                                                type='text'
                                                                value={formData.firstName || ''}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value.replace(/[^A-Za-z]/g, ''); // Allow only letters
                                                                    handleChange('firstName', inputValue);
                                                                }}
                                                                placeholder="Your first name"
                                                                sx={{ padding: '5px 5px', }}
                                                                Matches={matches}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ mt: '1em' }}>
                                                        <FormControl variant="standard">
                                                            <StyledInput shrink htmlFor="bootstrap-input" >Last Name</StyledInput>
                                                            <BootstrapInput
                                                                type='text'
                                                                value={formData.lastName || ''}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value.replace(/[^A-Za-z]/g, ''); // Allow only letters
                                                                    handleChange('lastName', inputValue);
                                                                }}
                                                                placeholder="Your last name"
                                                                sx={{ padding: '5px 5px' }}
                                                                Matches={matches}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ mt: '1em' }}>
                                                        {isLastStep && !showEmailMobile && (
                                                            <StyledBtn1
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleShowFields}
                                                                disabled={!steps[activeStep]?.fields || !formData[steps[activeStep].fields[0]]}
                                                                sx={{ width: '280px' }}
                                                            >
                                                                I'm ready to get started
                                                            </StyledBtn1>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            )
                                                :
                                                (<Grid item xs={12} >
                                                    <Typography
                                                        variant={steps[activeStep].fields[index] === "unit" ? "h5" : "h4"}
                                                        sx={{
                                                            mt: matches ? steps[activeStep].fields[index] === "unit" ? '2em' : '1em' : '1em',
                                                            mb: '1em',
                                                            color: '#fff',
                                                            fontSize: matches ? steps[activeStep].fields[index] === "unit" ? '15px' : '22px' : null,
                                                            fontWeight: matches ? steps[activeStep].fields[index] === "unit" ? 500 : 600 : null,
                                                            letterSpacing: '-0.03em',
                                                            // fontSize: steps[activeStep].fields[index] === "unit" ? '20px' : '28px',
                                                            // fontWeight: steps[activeStep].fields[index] === "unit" ? 400 : 600,
                                                        }}>{steps[activeStep].fieldName[index]}</Typography>
                                                    <BootstrapInput
                                                        label={field.charAt(0).toUpperCase() + field.slice(1)}
                                                        value={formData[field] || ''}
                                                        placeholder={steps[activeStep].defaultValue[index]}
                                                        onChange={(e) => handleChange(field, e.target.value)}
                                                        Matches={matches}
                                                    />
                                                </Grid>)
                                        }


                                    </>
                                )}
                            </Grid>

                        </div>
                    ))}
                    {isLastStep && showEmailMobile ? (
                        <Grid container spacing={2}>
                            <Grid item xs display='flex' flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: '10px' }} >
                                <Typography variant="h4" color='#fff' sx={{
                                    fontSize: matches ? '22px' : null,
                                    fontWeight: matches ? 600 : null,
                                    letterSpacing: '-0.03em',
                                }}>
                                    How should we contact you?
                                </Typography>
                                <Typography variant="h5" sx={{ borderBottom: '2px solid #444444', borderBottomWidth: '50%', width: '140px', mt: '10px', mb: '10px' }}></Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <FormControl variant="standard">
                                    <StyledInput shrink htmlFor="bootstrap-input">Email</StyledInput>
                                    <BootstrapInput
                                        required
                                        type='email'
                                        value={formData.email || ''}
                                        placeholder="Email Address"
                                        onChange={(e) => handleChange('email', e.target.value)}
                                        Matches={matches}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="standard">
                                    <StyledInput shrink htmlFor="bootstrap-input" >Phone Number</StyledInput>
                                    <BootstrapInput
                                        required
                                        type='tel'
                                        value={formData.mobile || ''}
                                        placeholder="123-456-7890"
                                        onChange={(e) => {
                                            const inputValue = e.target.value.replace(/\D/g, ''); // Allow only numeric characters
                                            const formattedValue = inputValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3'); // Add space after every three digits
                                            const maxLength = 12; // Adjust the maximum length as needed
                                            handleChange('mobile', formattedValue.slice(0, maxLength));
                                        }}
                                        Matches={matches}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                                <Stack sx={{ width: matches ? '300px' : '550px' }} spacing={0}>
                                    <FormControlLabel
                                        sx={{ m: 0 }}
                                        control={
                                            <BpCheckbox
                                                sx={{ mb: '1.8em' }}
                                                checked={isCheckboxChecked}
                                                onChange={(e) => setIsCheckboxChecked(e.target.checked)} />
                                        }
                                        label={matches ?
                                            <Typography color="#fff" fontSize="14px" sx={{ pt: '10px' }}>
                                                * I agree to receive text messages at the number provided. Message and data rates may apply. Full terms here.
                                            </Typography>
                                            :
                                            <Typography color="#fff" >
                                                * I agree to receive text messages at the number provided. Message and data rates may apply. Full terms here.
                                            </Typography>
                                        } />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sx={{ mb: '1em' }}>
                                {isLastStep && showEmailMobile && (
                                    <>  <StyledBtn1
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        disabled={!isCheckboxChecked}
                                        sx={{ width: matches ? '50%' : '10%' }}
                                    >
                                        Let's Go
                                    </StyledBtn1>
                                    </>
                                )}

                            </Grid>
                        </Grid>

                    ) : null}
                    <Snackbar
                        open={open}
                        autoHideDuration={4000}
                        onClose={handleSnackbarClose}
                    >
                        <Alert
                            onClose={handleSnackbarClose}
                            severity={isSuccess ? 'success' : 'error'}
                            color={isSuccess ? 'info' : 'error'}
                            variant="filled"
                        >
                            {isSuccess
                                ? 'Form submitted successfully!'
                                : 'Please fill in all fields.'}
                        </Alert>
                    </Snackbar>
                </>
                <Grid container spacing={2} sx={{ mt: '1em' }} diplay="flex" justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        {!isOptionsStep && !isLastStep && (
                            <StyledBtn
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                disabled={!steps[activeStep]?.fields || !formData[steps[activeStep].fields[0]]}
                                sx={{ width: '100px' }}
                            >
                                Next
                            </StyledBtn>
                        )}
                    </Grid>
                    {
                        matches ?
                            <Grid item xs={12} sx={{ position: 'absolute', bottom: showEmailMobile ? null : '2em' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '3em' }}>
                                    {steps.map((_, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                width: activeStep === index ? '20px' : '15px',
                                                height: activeStep === index ? '20px' : '15px',
                                                backgroundColor: activeStep === index ? '#444444' : '#fff',
                                                borderRadius: '50%',
                                                margin: activeStep === index ? '-3px 0px 0px 0px' : '0 5px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleStepChange(index)}
                                        />
                                    ))}
                                </div>
                            </Grid>
                            :
                            <Grid item xs={12} sx={{ position: 'absolute', bottom: showEmailMobile ? null : '5em' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2em' }}>
                                    {steps.map((_, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                width: activeStep === index ? '20px' : '15px',
                                                height: activeStep === index ? '20px' : '15px',
                                                backgroundColor: activeStep === index ? '#444444' : '#fff',
                                                borderRadius: '50%',
                                                margin: activeStep === index ? '-3px 0px 0px 0px' : '0 5px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleStepChange(index)}
                                        />
                                    ))}
                                </div>
                            </Grid>
                    }
                </Grid>
            </div>
        </div>
    );
};

export default SellingQuest;

